import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

export function useNavigateWithQuery() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const navigateWithQuery = useCallback(
    (args, options) => {
      let params;
      const search = searchParams.toString();

      if (typeof args === 'string') {
        params = { pathname: args, search };
      } else if (!!args && typeof args === 'object') {
        params = {
          ...args,
          search,
        };
      } else if (typeof args === 'number') {
        params = args;
      }

      navigate(params, options);
    },
    [navigate, searchParams]
  );
  return navigateWithQuery;
}
